import Modal from "react-bootstrap/Modal";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import axiApi from "ApiCaller";
import MessageHeader from "../../views/notifications/MessageHeader";
import ConditionalRender from "../ConditionalRender";
import {publishEvent} from "core/eventsConnector";

const Message = (props) => {
    const handleClose = () => props.setShowAlert(false);
    const navigate = useNavigate();
    const userLang = localStorage.getItem("i18nextLng") || "es";

    useEffect(() => {
        const id = props.itemSelected?.id;
        if (props.itemSelected.read) return;

        axiApi
            .post(`/api/notify/read/`, {id})
            .then((resp) => {
                props.itemSelected.read = true;
                publishEvent("messageRead", {id});
            })
            .catch((error) => {
                console.error("Error marking message as read:", error);
            });
    }, [props.itemSelected]);

    const onOpenProcessMonitor = () => {
        const msg = props.itemSelected;
        const taskId = msg.notify?.params?.task_id;
        navigate(`/process/monitor/${taskId}`);
        handleClose();
    };

    const getLocalizedText = () => {
        const texts = props.itemSelected.notify.texts || {};
        const text = texts[userLang] || texts["es"] || texts[Object.keys(texts)[0]] || {};
        return {
            title: text.title || "",
            description: text.description || "",
        };
    };

    const localizedText = getLocalizedText();

    return (
        <Modal
            show={props.showAlert}
            onHide={handleClose}
            className="modal-lg"
            animation={true}
            centered={true}
            backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{localizedText.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ConditionalRender condition={props.itemSelected}>
                    <MessageHeader
                        message={props.itemSelected}
                        localizedTitle={localizedText.title}
                        onOpenProcessMonitor={onOpenProcessMonitor}
                        showHr={false}
                        hideDownload={true}
                    />
                    <div dangerouslySetInnerHTML={{__html: localizedText.description}} />
                </ConditionalRender>
            </Modal.Body>
        </Modal>
    );
};

export default Message;
